<div class="merge-patient-modal">
  <div>
    <wfm-system-notification
      class="u-mb----"
      type="{{ notificationType }}"
      headingText="{{ 'mergePatient.confirmModal.header' | translate }}"
      [hideCloseButton]="true"
      [multiLineLayout]="true"
      [hideHeaderUtility]="true"
    >
    </wfm-system-notification>
  </div>
  <div class="modal__content u-mt">
    <div class="u-mb">
      <p class="text-18">{{ 'mergePatient.confirmModal.text' | translate }}</p>
    </div>
    <div class="flex">
      <div class="selected-patient-box u-mr++ u--1/2">
        <span class="text-16 u-small-mb">{{ 'mergePatient.mergeSoucePatient' | translate }}</span>
        <div
          *ngIf="source"
          class="patient-banner__container flex patient-banner__container--compressed patient-banner__container--collapsible patient-banner--dark"
        >
          <div class="patient-banner">
            <span class="patient-banner__name">{{ source.name }}</span>
          </div>
          <dl class="patient-banner__content flex flex--wrap u--1/1 patient-banner__content--compressed">
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.pid' | translate }}</dt>
              <dd
                [tooltip]="source.pid"
                [overflowOnly]="true"
                class="patient-banner__value--bold text-bold-16 text-ellipsis patient-banner__pid"
              >
                {{ source.pid }}
              </dd>
            </div>
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.dob' | translate }}</dt>
              <dd class="patient-banner__value--bold text-bold-16">
                {{ source.birthDate | dateTime: dateTimePref.dateFormat }}
              </dd>
            </div>
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.gender' | translate }}</dt>
              <dd class="patient-banner__value--bold text-bold-16">{{ source.gender }}</dd>
            </div>
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.age' | translate }}</dt>
              <dd class="patient-banner__value--bold text-bold-16">{{ sourceAge }}</dd>
            </div>
          </dl>
        </div>
      </div>
      <div slot="trigger" class="caretRightIcon">
        <svg-icon
          name="ico-caret-right-32"
          [svgStyle]="{ 'width.px': 24, 'height.px': 24, fill: 'currentColor' }"
          style="height: 27px"
        >
        </svg-icon>
      </div>
      <div class="u--1/2">
        <span class="text-16 u-small-mb">{{ 'mergePatient.toDestinationPatient' | translate }}</span>
        <div
          *ngIf="destination"
          class="patient-banner__container flex patient-banner__container--compressed patient-banner__container--collapsible patient-banner--dark"
        >
          <div class="patient-banner">
            <span class="patient-banner__name">{{ destination.name }}</span>
          </div>
          <dl class="patient-banner__content flex flex--wrap u--1/1 patient-banner__content--compressed">
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.pid' | translate }}</dt>
              <dd
                [tooltip]="destination.pid"
                [overflowOnly]="true"
                class="patient-banner__value--bold text-bold-16 text-ellipsis patient-banner__pid"
              >
                {{ destination.pid }}
              </dd>
            </div>
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.dob' | translate }}</dt>
              <dd class="patient-banner__value--bold text-bold-16">{{ destination.birthDate | dateTime: dateTimePref.dateFormat }}</dd>
            </div>
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.gender' | translate }}</dt>
              <dd class="patient-banner__value--bold text-bold-16">{{ destination.gender }}</dd>
            </div>
            <div class="patient-banner__data" aria-hidden="false">
              <dt class="patient-banner__value text-16">{{ 'label.age' | translate }}</dt>
              <dd class="patient-banner__value--bold text-bold-16">{{ destinationAge }}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
  <div class="modal__footer u-pt--">
    <button type="button" class="button button--primary button--accept" (click)="mergePatient($event)">
      {{ 'label.submit' | translate }}
    </button>
    <button type="button" class="button button--reject button--tertiary" (click)="goBack($event)">
      {{ 'label.goBack' | translate }}
    </button>
  </div>
</div>




<!-- PATIENT MERGE FAILURE TEMPLATE TEMPLATES -->
<ng-template #patientMergeFailure>
  <div> {{ smsFailureDisplay.msgheading | translate }} </div><br />
  <div>
    {{ 'studyManagement.sourcePatientDetailsHeading' | translate }}</div>
  <ul>
    <li>
      {{ 'workloadManager.listContainer.label.mrn' | translate }}
      :
      {{smsFailureDisplay.data.patientMRN}}
    </li>
    <li>
      {{ 'studyManagement.patName' | translate }}
      :
      {{smsFailureDisplay.data.patientName}}
    </li>
    <li>
      {{ 'workloadManager.listContainer.dateOfBirthLabel' | translate }}
      :
      {{smsFailureDisplay.data.patientDOB | dateTime: dateTimePref.dateFormat}}
    </li>
  </ul>
</ng-template>